export default __webpack_public_path__ + "static/media/Breastplate of the Scattered Gods.03fac688.jpg";